import { useEffect, useState } from "react";
import Link from "next/link";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  fetchCollaborationSliders,
  showAppModal,
  fetchCollaborations,
  checkCategoryFlags,
  fetchCollaboration,
} from "redux/actions/app";

import UserAvatar from "components/user/UserAvatar";
import CollaborationTags from "~/components/collaborations/CollaborationTags";
import SiteLayout from "components/layout/SiteLayout";
import CitySwiper from "components/cities/CitySwiper";
import CategoryFollowButton from "~/components/categories/CategoryFollowButton";
import moment from "moment";
import { findMatchingEle } from "~/utils/app";
import { useRouter } from "next/router";
import UserAvatarGroup from "~/components/user/UserAvatarGroup";

// Images
import pureEleIcon from "~/public/static/icons/pure_ele.png";

const Page = ({
  collaborations: collaborationsProp,
  sliders,
  user,
  token,
  flags,
  checkCategoryFlags,
  showAppModal,
  fetchCollaboration,
}: any) => {
  const [collaborations, setCollaborations] = useState(collaborationsProp);
  const router = useRouter();

  const more = (collaboration: any) => {
    return (
      <Link
        legacyBehavior
        as={`/collaborations/${collaboration.category.id}`}
        href="/collaborations/[id]"
      >
        <a>
          <div className="more-users"></div>
        </a>
      </Link>
    );
  };

  useEffect(() => {
    if (token) {
      checkCategoryFlags(
        token,
        ["followed", "paid"],
        collaborations.map((c: any) => c.category.hashid)
      );
    }
  }, [token]);
  return (
    <SiteLayout
      pageTitle="共学共创"
      pageHeader={<CitySwiper images={sliders} />}
      largeContainer
    >
      <div className="collaborations-container">
        <div className="small-container">
          {collaborations &&
            collaborations.map((collaboration: any, index: number) => {
              const isFollowed = flags.followed.includes(
                collaboration.category.hashid
              );
              return (
                <div
                  key={collaboration.id}
                  className={`collaboration-wrapper ${
                    index % 2 !== 0 && "collaboration-wrapper-reverse"
                  }`}
                >
                  <Link
                    legacyBehavior
                    as={`/collaborations/${collaboration.category.id}`}
                    href="/collaborations/[id]"
                  >
                    <a className="left">
                      <div>
                        <img
                          className="cover"
                          src={collaboration.cover_url}
                        />
                        <CollaborationTags
                          collaboration={collaboration}
                          className="hide-in-mp"
                        />
                      </div>
                    </a>
                  </Link>
                  <div className="right">
                    <div className="collaboration-info">
                      <Link
                        legacyBehavior
                        href={`/collaborations/${collaboration.category.id}`}
                      >
                        <a className="collaboration-name">
                          {collaboration.category.name}
                        </a>
                      </Link>
                      <div className="join-wrapper">
                        <div className="ele-wrapper">
                          <img src={pureEleIcon.src} />
                          <span>{findMatchingEle(collaboration.category)}</span>
                        </div>
                        <CategoryFollowButton
                          name="共学"
                          followText="加入"
                          unfollowText="已加入"
                          className={`follow-btn ${
                            isFollowed ? "followed-btn" : undefined
                          }`}
                          category={collaboration.category}
                          isFollowed={isFollowed}
                          disabled={isFollowed}
                          onFollowed={(category: any) => {
                            checkCategoryFlags(
                              token,
                              ["followed", "paid"],
                              collaborations.map((c: any) => c.category.hashid)
                            );
                            fetchCollaborations(user.id).then((res: any) => {
                              setCollaborations(res);
                              router.push({
                                pathname: `/collaborations/${category.id}`,
                                query: { showQrcode: true },
                              });
                            });
                          }}
                          onUnfollow={() => {}}
                        />
                      </div>
                    </div>
                    <div className="followed-users">
                      <div className="mp-users">
                        {collaboration.category.recent_followed_users
                          .slice(0, 5)
                          .map((user: any) => (
                            <UserAvatar
                              size={20}
                              user={user}
                              key={user.id}
                            />
                          ))}
                        {collaboration.category.recent_followed_users.length >
                          5 && more(collaboration)}
                        <div className="total-count">
                          <span>{collaboration.category.followed_count}</span>
                          个已加入
                        </div>
                      </div>
                      <div className="pc-users">
                        {collaboration.category.recent_followed_users
                          .slice(0, 19)
                          .map((user: any) => (
                            <UserAvatar
                              key={user.id}
                              size={44}
                              user={user}
                            />
                          ))}
                        {collaboration.category.recent_followed_users.length >
                          19 && more(collaboration)}
                        <div className="total-count">
                          <span>{collaboration.category.followed_count}</span>
                          个已加入
                        </div>
                      </div>
                    </div>
                    <div className="owner-info">
                      <UserAvatarGroup
                        users={[
                          ...(collaboration.category.user
                            ? [collaboration.category.user]
                            : []),
                          ...collaboration.category.moderators.map(
                            (m: any) => m.user
                          ),
                        ]}
                      />
                      <div className="date">
                        {collaboration.start_date}
                        发起
                      </div>
                    </div>

                    <div className="line"></div>
                    <CollaborationTags
                      collaboration={collaboration}
                      className="hide-in-pc"
                    />
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </SiteLayout>
  );
};
const mapStateToProps = (state: any) => ({
  token: state.user.token,
  user: state.user.user,
  flags: state.app.flags,
});
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      showAppModal,
      checkCategoryFlags,
      fetchCollaboration,
    },
    dispatch
  );

Page.getInitialProps = async (ctx: any) => {
  const { store } = ctx;

  const collaborations = await fetchCollaborations(store.getState().user.token);
  const sliders = await fetchCollaborationSliders({
    kind: "collaboration",
    listed: true,
    collaboration_id: "",
  });

  return {
    collaborations,
    sliders,
  } as any;
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);
